import styled from "styled-components";

const SubTitle = styled.h3`
  font-size: 25px;
  text-align: center;
`;
export default SubTitle;
